// Returns true if the given ISO timestamp is within the last 24 hours.
// Used to surface a "Just tagged" pip on assets that were recently edited.
export function isRecentlyTagged(updatedAt) {
  if (!updatedAt) return false;
  const t = Date.parse(updatedAt);
  if (Number.isNaN(t)) return false;
  return Date.now() - t < 24 * 60 * 60 * 1000;
}
